import { CustomizacaoSubmenuEnum } from "src/app/shared/enums/CustomizacaoSubmenuEnum";
import { Component, OnInit } from "@angular/core";
import { ParametrosKey } from "src/app/shared/enums/parametros.enum";
import { Router } from "@angular/router";
import { ParametrosDataService } from "src/app/services/parametros-data.service";
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: "app-centro-custo",
    templateUrl: "./centro-custo.component.html"
})
export class CentroCustoComponent implements OnInit {
    constructor(
        private alertService: NewAlertService,
        private parametrosDataService: ParametrosDataService,
        private router: Router
    ) {}

    ngOnInit() {
        const canAccess = this.parametrosDataService.ShowSubmenu(
            CustomizacaoSubmenuEnum.centroCusto
        );

        if (!canAccess) {
            this.router.navigate(["accessdenied"]);
        }
    }
}
